import { defineStore } from 'pinia'

const useHelpRecipientStore = defineStore('help-recipient', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useHelpRecipientStore
